import { extract } from '../extractors/socialMomentum';

const txt = (lang, zh, en) => (lang === 'en' ? en : zh);
const fmtK = n => n == null ? '—' : n >= 1000 ? `${(n/1000).toFixed(1)}K` : `${n}`;

export function getSocialEvidence(project, a, lang = 'zh') {
  const d = extract(project, a);
  if (!d) return [];
  const rows = [];
  if (d.twitterFollowers != null)
    rows.push({ label: txt(lang, 'Twitter 粉丝', 'Twitter Followers'), val: fmtK(d.twitterFollowers), source: 'CoinGecko', positive: d.twitterFollowers > 10000 });
  if (d.watchlistUsers != null)
    rows.push({ label: txt(lang, 'CG Watchlist 用户', 'CG Watchlist'), val: fmtK(d.watchlistUsers), source: 'CoinGecko' });
  if (d.telegramSubscribers != null && d.telegramSubscribers > 0)
    rows.push({ label: txt(lang, 'Telegram 订阅', 'Telegram'), val: fmtK(d.telegramSubscribers), source: 'CoinGecko' });
  if (d.redditSubscribers != null && d.redditSubscribers > 0)
    rows.push({ label: txt(lang, 'Reddit 订阅', 'Reddit'), val: fmtK(d.redditSubscribers), source: 'CoinGecko' });
  if (d.bullishSentimentPct != null)
    rows.push({ label: txt(lang, '社区看涨情绪', 'Bullish Sentiment'), val: `${Math.round(d.bullishSentimentPct)}%`, source: 'CoinGecko', positive: d.bullishSentimentPct >= 60 });
  return rows;
}

// 无独立 Card 渲染 — social momentum 信号体量小，直接挂在 narrative/data evidence row 即可
// 如未来需要独立卡片，再加 export SocialMomentumCard
